import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector
} from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { API_PATH } from '../../constants';
import { IGameStatus } from '../../interfaces';
import { GameStatus } from '../../Classes1';
import { http } from '../../utils/config';
import { AxiosResponse } from 'axios';

const gameAdapter = createEntityAdapter<IGameStatus>({
  selectId: (game) => game.gameId
})

const initialState = gameAdapter.getInitialState()

// Thunk functions
export const fetchGames = createAsyncThunk('game/fetchGames', async (blah, { rejectWithValue }) => {
  try {
    const response = await http.get(`${API_PATH}/game`)
    return response.data as IGameStatus[];
  } catch (error: any) {
    if (error.response) {
      const axisoResp = error.response as AxiosResponse;
      const errorMsg = typeof axisoResp.data === 'string' ? axisoResp.data : axisoResp.data.message || axisoResp.data.error;
      const blankStatus = new GameStatus();
      return [{
        ...blankStatus,
        errorCode: axisoResp.status,
        error: errorMsg,
      }];
    } else {
      return rejectWithValue(error.message)
    }
  }
})

const gameSlice = createSlice({
    name: 'games',
    initialState,
    reducers: {
      gameToggled(state, action) {
        //const scenarioId = action.payload
      },
    },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGames.fulfilled, (state, action) => {
        gameAdapter.setAll(state, action.payload)
      })
  },
})

export const {
  gameToggled
} = gameSlice.actions

export default gameSlice.reducer

export const {
  selectAll: selectGames
} = gameAdapter.getSelectors((state: RootState) => state.games)

// Join Game
export const joinGame = createAsyncThunk(
  'games/joinGame',
  async ({ id, password }: { id: string, password: string }, { rejectWithValue }) => {
    try {
      const response = await http.post(API_PATH + '/game/' + id + '/join', { 'password': password });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

// Host Game
export const hostGame = createAsyncThunk(
  'games/hostGame',
  async ({ id, gameName, password }: { id: string, gameName: string, password: string }, { rejectWithValue }) => {
    try {

      let response: any = {}
      response = await http.post(API_PATH + '/game/new', { scenarioId: id, gameName: gameName, password: password });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

// Post Role
export const postRole = createAsyncThunk(
    'games/postRole',
    async ({ gameId, role, playerId }: any, { rejectWithValue }) => {
      try {
  
        let response: any = {}
        response = await http.post(`${API_PATH}/game/${gameId}/role`, { role, playerId });
        let respObj: any = {};
        respObj.status = response.status;
        respObj.scenario = response.data;
        return respObj
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

// Post Organization
export const postOrganization = createAsyncThunk(
  'games/postOrganization',
  async (postOrgObj: any, { rejectWithValue }) => {
    try {

      let response: any = {}
      response = await http.post(API_PATH + '/game/' + postOrgObj.gameId + '/organization', { orgId: postOrgObj.orgId, playerId: postOrgObj.playerId });
      let respObj: any = {};
      respObj.status = response.status;
      respObj.scenario = response.data;
      return respObj
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

// Post Ready
export const postReady = createAsyncThunk(
    'games/postReady',
    async ({ gameId, ready, playerId }: { gameId: string, ready: boolean, playerId: string }, { rejectWithValue }) => {
      try {
        let response: any = {}
        response = await http.post(`${API_PATH}/game/${gameId}/ready`, { ready, playerId });
        let respObj: any = {};
        respObj.status = response.status;
        respObj.scenario = response.data;
        return respObj
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

// Post Host
export const postHost = createAsyncThunk(
  'games/postHost',
  async ({ gameId, hostId }: { gameId: string, hostId: string }, { rejectWithValue }) => {
    try {
      let response: any = {}
      response = await http.post(`${API_PATH}/game/${gameId}/host`, { hostId });
      let respObj: any = {};
      respObj.status = response.status;
      respObj.scenario = response.data;
      return respObj
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

  // Leave Game
export const leaveGame = createAsyncThunk(
    'games/leaveGame',
    async (gameId: string, { rejectWithValue }) => {
      try {
  
        let response: any = {}
        response = await http.post(API_PATH + '/game/' + gameId + '/leave', { game_id: gameId });
        let respObj: any = {};
        respObj.status = response.status;
        respObj.scenario = response.data;
        return respObj
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
)

  // Leave Game
  export const isHosting = createAsyncThunk(
    'games/isHosting',
    async (hostId: string, { rejectWithValue }) => {
      try {
        let response = await http.post(API_PATH + '/game/hosting', { hostId });
        return response.data;
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
)

  // kick Game
export const kickFromGame = createAsyncThunk(
    'games/kickFromGame',
    async (kickObj: any, { rejectWithValue }) => {
      try {
  
        let response: any = {}
        response = await http.post(API_PATH + '/game/' + kickObj.gameId + '/kick', { targetUserId: kickObj.playerId });
        let respObj: any = {};
        respObj.status = response.status;
        respObj.scenario = response.data;
        return respObj
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

// Start Game
export const startGame = createAsyncThunk(
    'games/startGame',
    async (gameId: any) => {
      try {
  
        let response: any = {}
        response = await http.post(API_PATH + '/game/' + gameId + '/start', {});
        let respObj: any = {};
        respObj.status = response.status;
        respObj.scenario = response.data;
        return respObj
      } catch (error: any) {
        return error.response;
      }
    }
  )

// Start Hotwash
export const startHotwash = createAsyncThunk(
  'games/startHotwash',
  async (gameId: any) => {
    try {

      let response: any = {}
      response = await http.post(API_PATH + '/game/' + gameId + '/hotwash', { startHotwash: true });

      return response.data
    } catch (error: any) {
      return error.response;
    }
  }
)

// Game Status
export const gameStatus = createAsyncThunk(
    'games/gameStatus',
    async (gameId: any, { rejectWithValue }) => {
      try {
  
        let response: any = {}
        response = await http.get(API_PATH + '/game/' + gameId + '/status');
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  // Vote
export const gameVote = createAsyncThunk(
    'games/gameVote',
    async ({ gameId, voteObj }: { gameId: string, voteObj: any }, { rejectWithValue }) => {
      try {
  
        let response: any = {}
        response = await http.post(API_PATH + '/game/' + gameId + '/vote', voteObj);
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

    // Vote
export const updateGameStyle = createAsyncThunk(
  'games/gameVote',
  async ({ gameId, gameStyle }: { gameId: string, gameStyle: string }, { rejectWithValue }) => {
    try {
      
      let response: any = {}
      response = await http.post(API_PATH + '/game/' + gameId + '/style', { style: gameStyle });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteGame = createAsyncThunk(
  'games/deleteGame',
  async (gameId: string, { rejectWithValue }) => {
    try {

      let response: any = {}
      response = await http.delete(API_PATH + '/game/' + gameId);
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const selectGamesSlice = createSelector(
  selectGames,
  (games: IGameStatus[]) => {
    return games.map((game: IGameStatus) => {
      return game;
    })
  }
)
